import { createFileRoute, redirect } from '@tanstack/react-router';

/** Old top-level path; audit lives under Settings now. */
export const Route = createFileRoute('/audit')({
  beforeLoad: () => {
    throw redirect({ to: '/settings/audit', replace: true });
  }
});
